/**
 * Returns the listeners that pass the shared result layout's events on as the card element's own events.
 *
 * @param {Function} emit the card element's `emit`
 * @returns {Object<String, Function>} listeners for `v-on`
 */
export function createFinderResultListeners(emit) {
  function forward(name) {
    return function forwardFinderResultEvent(payload) {
      emit(name, payload);
    };
  }

  return {
    "add-filters": forward("add-filters"),
    "show-map": forward("show-map"),
    "show-more-slots": forward("show-more-slots"),
    "show-date": forward("show-date"),
    "toggle-other-locations": forward("toggle-other-locations"),
    "retry-other-locations": forward("retry-other-locations"),
  };
}
